<template>
   <div>
      <div class="spinner-container" v-if="loadingPage">
         <BeatLoader color="#1389EF" />
      </div>
      <div v-else>
         <form @submit.prevent="valider">
            <div class="sous-titre">
               <b-icon icon="information" class="my-icone"></b-icon>Informations générales
            </div>

            <!-- PREMIERE LIGNE ******************************* -->
            <div class="columns is-mobile container-mobile">
               <div class="column is-half">
                  <div style="margin-left:20px; height:35px;" v-if="loadingRuches">
                     <BeatLoader color="#1389EF" style="margin-top:20px;" />
                  </div>
                  <b-field
                     v-else
                     label="Ruche"
                     :type="form.errors.has('ruche_id') ? 'is-danger' : ''"
                     :message="form.errors.get('ruche_id')"
                  >
                     <b-select
                        placeholder="Choisir ..."
                        v-model="form.ruche_id"
                        expanded
                        @input="getDerniereVisite"
                     >
                        <option
                           v-for="ruche in ruches"
                           :value="ruche.id"
                           :key="ruche.id"
                        >{{ ruche.nom }}</option>
                     </b-select>
                  </b-field>
               </div>
               <div class="column is-half">
                  <b-field
                     label="Date de visite"
                     :type="form.errors.has('date') ? 'is-danger' : ''"
                     :message="form.errors.get('date')"
                  >
                     <!-- <b-datepicker
                        v-model="form.date"
                        placeholder="Sélectionnez une date"
                        :month-names="month_names"
                        icon="calendar-today"
                     ></b-datepicker>-->
                     <b-input v-model="form.date" type="date"></b-input>
                  </b-field>
               </div>
            </div>

            <!-- DEUXIEME LIGNE *********************** -->
            <div class="columns is-mobile container-mobile">
               <!-- poids  -->
               <div class="column is-half">
                  <b-field
                     label="Poids (kg)"
                     :type="form.errors.has('poids') ? 'is-danger' : ''"
                     :message="form.errors.get('poids')"
                  >
                     <b-input v-model="form.poids" type="number" step="any"></b-input>
                  </b-field>
               </div>
               <!-- comportement -->
               <div class="column is-half">
                  <b-field
                     label="Comportement"
                     :type="form.errors.has('comportement') ? 'is-danger' : ''"
                     :message="form.errors.get('comportement')"
                  >
                     <b-select placeholder="Choisir ..." v-model="form.comportement" expanded>
                        <option value="Aggressives">Aggressives</option>
                        <option value="Douces">Douces</option>
                     </b-select>
                  </b-field>
               </div>
            </div>

            <!-- TROISIEME LIGNE /********************* */ -->
            <div class="columns is-mobile container-mobile">
               <!-- réserves de miel  -->
               <div class="column is-half">
                  <b-field
                     label="Réserves de miel"
                     :type="form.errors.has('reserves_miel') ? 'is-danger' : ''"
                     :message="form.errors.get('reserves_miel')"
                  >
                     <b-input type="number" v-model="form.reserves_miel"></b-input>
                  </b-field>
               </div>
               <!-- Nombre cadres d'abeilles -->
               <div class="column is-half"></div>
            </div>

            <!-- TITRE :  SUIVI ************************************************ -->
            <div class="sous-titre">
               <b-icon icon="archive" class="my-icone"></b-icon>Suivi de la colonie
            </div>

            <!-- 4e ligne  -->
            <div class="columns is-mobile container-mobile">
               <!-- cadres de couvain  -->
               <div class="column is-half">
                  <b-field
                     label="Nbr. cadres couvain"
                     :type="form.errors.has('nombre_cadres_couvain') ? 'is-danger' : ''"
                     :message="form.errors.get('nombre_cadres_couvain')"
                  >
                     <b-input type="number" v-model="form.nombre_cadres_couvain"></b-input>
                  </b-field>
               </div>
               <!-- Nombre cadres d'abeilles -->
               <div class="column is-half">
                  <b-field
                     label="Nbr. cadres d'abeilles"
                     :type="form.errors.has('nombre_cadres_abeilles') ? 'is-danger' : ''"
                     :message="form.errors.get('nombre_cadres_abeilles')"
                  >
                     <b-input type="number" v-model="form.nombre_cadres_abeilles"></b-input>
                  </b-field>
               </div>
            </div>

            <!-- 5e ligne = toutes les checkboxes  -->
            <div class="columns container-mobile">
               <div class="column is-half" style="padding-bottom:0px;">
                  <!-- grille à reine  -->
                  <div class="field">
                     <b-switch
                        :true-value="1"
                        v-model="form.grilles_a_reine"
                     >Grille à reine installée</b-switch>
                  </div>
                  <div class="field">
                     <b-switch :true-value="1" v-model="form.elite">Colonie élite</b-switch>
                  </div>

                  <div class="field">
                     <b-switch :true-value="1" v-model="form.orpheline">Ruche orpheline</b-switch>
                  </div>
                  <div class="field">
                     <b-switch :true-value="1" v-model="form.essaimee">La colonie a essaimée</b-switch>
                  </div>
                  <div class="field">
                     <b-switch :true-value="1" v-model="form.bourdonneuse">Colonie bourdonneuse</b-switch>
                  </div>
               </div>

               <!-- DEUXIEME colonne de checkboxex -->
               <div class="column is-half">
                  <div class="field">
                     <b-switch :true-value="1" v-model="form.crn_crnop">Cellule royale naturelle</b-switch>
                  </div>
                  <div class="field">
                     <b-switch :true-value="1" v-model="form.reine_vierge">Reine vierge</b-switch>
                  </div>
                  <div class="field">
                     <b-switch :true-value="1" v-model="form.reine_a_changer">Reine à changer</b-switch>
                  </div>
                  <div class="field">
                     <b-switch :true-value="1" v-model="form.ddp">En début de ponte</b-switch>
                  </div>

                  <div class="field">
                     <b-switch
                        :true-value="1"
                        v-model="form.division_colonie"
                     >Division de la colonie</b-switch>
                  </div>
                  <b-field
                     v-if="form.division_colonie"
                     label="Combien de cadres pris ?"
                     :type="form.errors.has('nombre_cadres_pris') ? 'is-danger' : ''"
                     :message="form.errors.get('nombre_cadres_pris')"
                  >
                     <b-input type="number" v-model="form.nombre_cadres_pris"></b-input>
                  </b-field>
               </div>
            </div>

            <!-- TITRE : Nourrissement ********************* -->
            <div class="sous-titre">
               <b-icon icon="food" class="my-icone"></b-icon>Nourrissement
            </div>
            <!-- 6e ligne **********************  nourrissement-->
            <div class="columns is-mobile container-mobile">
               <div class="column is-half">
                  <b-field
                     label="Qté de sirop (L)"
                     :type="form.errors.has('sirop') ? 'is-danger' : ''"
                     :message="form.errors.get('sirop')"
                  >
                     <b-input type="number" step="any" v-model="form.sirop"></b-input>
                  </b-field>
               </div>
               <div class="column is-half">
                  <b-field
                     label="Qté de candi (kg)"
                     :type="form.errors.has('candi') ? 'is-danger' : ''"
                     :message="form.errors.get('candi')"
                  >
                     <b-input type="number" step="any" v-model="form.candi"></b-input>
                  </b-field>
               </div>
            </div>
            <div class="container-mobile">
               <div class="field">
                  <b-switch
                     :true-value="1"
                     v-model="form.nourrissement_a_prevoir"
                  >Nourrissement à prévoir</b-switch>
               </div>
            </div>

            <!-- TITRE : SANITAIRE ****************** -->
            <div class="sous-titre" style="margin-top:25px;">
               <b-icon icon="medical-bag" class="my-icone"></b-icon>Sanitaire
            </div>

            <!-- 7e ligne ******** -->
            <div class="columns container-mobile">
               <!-- col1  -->
               <div class="column is-half">
                  <!-- traitement à prévoir  -->
                  <div class="field">
                     <b-switch
                        :true-value="1"
                        v-model="form.traitement_a_prevoir"
                     >Traitement à prévoir</b-switch>
                  </div>
                  <!-- traitement fait  -->
                  <div class="field">
                     <b-switch :true-value="1" v-model="form.traitement_fait">Traitement fait</b-switch>
                  </div>
               </div>
               <!-- col2 -->
               <div class="column is-half">
                  <!-- nettoyage planchers  -->
                  <div class="field">
                     <b-switch
                        :true-value="1"
                        v-model="form.nettoyage_planchers_fait"
                     >Nettoyage planchers fait en {{ annee }}</b-switch>
                  </div>
                  <!-- renouvellement cadres  -->
                  <div class="field">
                     <b-switch
                        :true-value="1"
                        v-model="form.renouvellement_cadres"
                     >Renouvellement des cadres fait en {{ annee }}</b-switch>
                  </div>
               </div>
            </div>

            <!-- TITRE : RECOLTE ********************************************* -->
            <div class="sous-titre" style="margin-top:25px;">
               <b-icon icon="water" class="my-icone"></b-icon>Récolte
            </div>
            <!-- 8e ligne ************************************* -->
            <div class="columns is-mobile container-mobile">
               <!-- récolte ID  -->
               <div class="column is-half">
                  <div style="margin-left:20px; height:35px;" v-if="loadingRecoltes">
                     <BeatLoader color="#1389EF" style="margin-top:20px;" />
                  </div>
                  <b-field
                     v-else
                     label="Récolte"
                     :type="form.errors.has('variete_id') ? 'is-danger' : ''"
                     :message="form.errors.get('variete_id')"
                  >
                     <b-select placeholder="Choisir ..." v-model="form.variete_id" expanded>
                        <option
                           v-for="variete in varietes"
                           :value="variete.id"
                           :key="variete.id"
                        >{{ variete.nom }}</option>
                     </b-select>
                  </b-field>
               </div>
               <div class="column is-half">
                  <b-field
                     label="Qté miel récolté (kg)"
                     :type="form.errors.has('quantite_miel_recoltee') ? 'is-danger' : ''"
                     :message="form.errors.get('quantite_miel_recoltee')"
                  >
                     <b-input type="number" step="any" v-model="form.quantite_miel_recoltee"></b-input>
                  </b-field>
               </div>
            </div>
            <div class="columns is-mobile container-mobile">
               <!-- hausses récoltées  -->
               <div class="column is-half">
                  <b-field
                     label="Hausses récoltées"
                     :type="form.errors.has('hausses_recoltees') ? 'is-danger' : ''"
                     :message="form.errors.get('hausses_recoltees')"
                  >
                     <b-input type="number" step="any" v-model="form.hausses_recoltees"></b-input>
                  </b-field>
               </div>
               <!-- hausses posées -->
               <div class="column is-half">
                  <b-field
                     label="Hausses posées"
                     :type="form.errors.has('hausses_posees') ? 'is-danger' : ''"
                     :message="form.errors.get('hausses_posees')"
                  >
                     <b-input type="number" step="any" v-model="form.hausses_posees"></b-input>
                  </b-field>
               </div>
            </div>
            <!-- renouvellement cadres  -->
            <div class="field container-mobile">
               <b-switch :true-value="1" v-model="form.hausses_a_poser">Hausses à poser</b-switch>
            </div>

            <!-- TITRE : POLLEN ********************************************* -->
            <div class="sous-titre" style="margin-top:25px;">
               <b-icon icon="grain" class="my-icone"></b-icon>Trappes à pollen
            </div>

            <div class="columns is-mobile container-mobile">
               <!-- pollen qté récoltée -->
               <div class="column is-half">
                  <b-field
                     label="Qté pollen récoltée"
                     :type="form.errors.has('quantite_pollen_recoltee') ? 'is-danger' : ''"
                     :message="form.errors.get('quantite_pollen_recoltee')"
                  >
                     <b-input type="number" step="any" v-model="form.quantite_pollen_recoltee"></b-input>
                  </b-field>
               </div>
               <div class="column is-half"></div>
            </div>

            <!-- trappes activées ? -->
            <div class="field container-mobile">
               <b-switch :true-value="1" v-model="form.trappes_a_pollen_activees">Trappes activées</b-switch>
            </div>

            <!-- TITRE : info diverses ********************************************* -->
            <div class="sous-titre" style="margin-top:25px;">
               <b-icon icon="comment" class="my-icone"></b-icon>Commentaires
            </div>
            <b-field class="container-mobile">
               <b-input rows="2" v-model="form.commentaires" type="textarea"></b-input>
            </b-field>

            <!-- TITRE : taches ********************************************* -->
            <div class="flex sous-titre" style="margin-top:25px; justify-content:space-between;">
               <div class="text-center">
                  <b-icon icon="tools" class="my-icone"></b-icon>Tâches apicoles
               </div>
               <div>
                  <b-button type="is-success" icon-left="plus" @click="ajouterTache"></b-button>
               </div>
            </div>
            <div class="flex container-mobile" v-for="(tache, index) in form.taches" :key="index">
               <b-field style="width:100%">
                  <b-input v-model="tache.nom" placeholder="Nouvelle tâche à prévoir"></b-input>
               </b-field>
               <div class="flex" @click="retirerTache(index)" style="cursor: pointer">
                  <b-icon
                     icon="close-circle"
                     type="is-danger"
                     style="margin-top:6px; margin-left:8px;"
                  ></b-icon>
               </div>
            </div>
            <div class="flex container-mobile" style="justify-content:space-between">
               <b-button
                  style="margin-top:25px"
                  icon-left="check"
                  size="is-medium"
                  native-type="submit"
                  type="is-primary"
               >Valider</b-button>
               <b-button
                  style="margin-top:25px"
                  icon-left="arrow-left"
                  size="is-medium"
                  type="is-light"
                  @click="back"
               >Retour</b-button>
            </div>
         </form>
      </div>
   </div>
</template>

<script>
   import moment from "moment/src/moment";
   import { BeatLoader } from "@saeris/vue-spinners";
   import axios from "axios";
   import { Form } from "vform";

   export default {
      components: {
         BeatLoader
      },
      props: {
         mode: String
      },
      data() {
         return {
            annee: new Date().getFullYear(),
            ruches: [],
            varietes: [],
            loadingPage: false,
            loadingRecoltes: false,
            loading: false,
            loadingRuches: false,
            form: new Form({
               ruche_id: this.$route.params.ruche_id || null,
               date: null,
               comportement: "Douces",
               poids: null,
               nombre_cadres_couvain: null,
               nombre_cadres_abeilles: null,
               grilles_a_reine: false,
               commentaires: "",
               division_colonie: false,
               nombre_cadres_pris: null,
               orpheline: false,
               bourdonneuse: false,
               reine_vierge: false,
               elite: false,
               essaimee: false,
               crn_crnop: false,
               ddp: false,
               reine_a_changer: false,
               sirop: null,
               candi: null,
               nourrissement_a_prevoir: false,
               variete_id: null,
               hausses_posees: null,
               hausses_recoltees: null,
               quantite_miel_recoltee: null,
               hausses_a_poser: false,
               trappes_a_pollen_activees: false,
               quantite_pollen_recoltee: null,
               traitement_a_prevoir: false,
               traitement_fait: false,
               nettoyage_planchers_fait: false,
               renouvellement_cadres: false,
               reserves_miel: null,
               taches: [{ nom: "" }]
            })
         };
      },
      mounted() {
         this.getRuches();
         this.getRecoltes();
         if (this.mode === "edit") {
            this.getVisite();
         }
         if (this.mode === "create") {
            if (this.$route.params.ruche_id) {
               this.getDerniereVisite();
            }

            let date = new Date();
            this.form.date = moment(date).format("YYYY-MM-DD");
         }
      },
      methods: {
         back() {
            window.history.back();
         },
         async getRuches() {
            this.loadingRuches = true;
            let res = await axios.get("/ruches");
            this.ruches = res.data.data;
            this.loadingRuches = false;
         },
         async getRecoltes() {
            this.loadingRecoltes = true;
            let res = await axios.get("/varietes");
            this.varietes = res.data;
            this.loadingRecoltes = false;
         },
         async getVisite() {
            let id = this.$route.params.id;
            this.loadingPage = true;
            let res = await axios.get("/visites/" + id);
            if (res.data.erreur) {
               this.$buefy.toast.open({
                  message: res.data.erreur,
                  type: "is-danger"
               });
               this.$router.push({ name: "visites" });
            }
            this.form.fill(res.data.visite);
            this.form.taches = res.data.taches;
            this.loadingPage = false;
         },
         async getDerniereVisite() {
            if (this.mode === "create") {
               let id = this.form.ruche_id;
               let res = await axios.get("/ruches/" + id + "/derniere-visite");
               if (res.data) {
                  this.form.renouvellement_cadres = res.data.renouvellement_cadres;
                  this.form.nettoyage_planchers_fait =
                     res.data.nettoyage_planchers_fait;
               } else {
                  this.form.renouvellement_cadres = this.form.nettoyage_planchers_fait = 0;
               }
            }
         },
         ajouterTache() {
            this.form.taches.push({ nom: "" });
         },
         retirerTache(id) {
            this.form.taches.splice(id, 1);
         },
         valider() {
            // pour une création
            if (this.mode === "create") {
               this.form
                  .post("/visites")
                  .then(res => {
                     if (res.data.erreur) {
                        this.$buefy.toast.open({
                           message: res.data.erreur,
                           type: "is-danger"
                        });
                     } else {
                        this.$buefy.toast.open({
                           message: "Visite créée !",
                           type: "is-success"
                        });
                        this.$router.push({ name: "visites" });
                     }
                  })
                  .catch(() => {
                     this.$buefy.toast.open({
                        message:
                           "Des erreurs ont été trouvées dans le formulaire.",
                        type: "is-danger"
                     });
                  });
            } else if (this.mode === "edit") {
               this.form
                  .put("/visites/" + this.$route.params.id)
                  .then(res => {
                     if (res.data.erreur) {
                        this.$buefy.toast.open({
                           message: res.data.erreur,
                           type: "is-danger"
                        });
                     } else {
                        this.$buefy.toast.open({
                           message: "Visite modifiée !",
                           type: "is-success"
                        });
                        this.$router.push({ name: "visites" });
                     }
                  })
                  .catch(() => {
                     this.$buefy.toast.open({
                        message:
                           "Des erreurs ont été trouvées dans le formulaire.",
                        type: "is-danger"
                     });
                  });
            }
         }
      }
   };
</script>
